import { z } from "zod";

const zRetrieveFrom = z.enum(["SERVER", "LOCAL_STORAGE"]).catch("SERVER");
const RetrieveFrom = zRetrieveFrom._def.innerType.Enum;
type RetrieveFrom = z.infer<typeof zRetrieveFrom>;

export { RetrieveFrom, zRetrieveFrom };
